<script>
import { abbreviateStockTypeUnit, unitToDisplayText } from '@/layer/filters/units';
import StockService from '@/layer/services/stock';

export default {
  filters: {
    abbreviateStockTypeUnit,
    unitToDisplayText,
  },

  props: {
    value: { type: Number, required: true },
    typeName: { type: String, required: true },
    unit: { type: String }, required: true,
    quantityPerBox: { type: Number },
  },

  data: function () {
    let { boxes, remaining } = StockService.splitQuantityBoxesAndRemaining(this.value, this.quantityPerBox);
    return {
      boxes: boxes,
      remaining: remaining,
    };
  },

  computed: {
    showBoxes() { return this.quantityPerBox > 0 },
  },

  watch: {
    boxes(to) { this.updateTotal(); },
    remaining(to) { this.updateTotal(); },
  },

  methods: {
    updateTotal() {
      let total = this.showBoxes ? Number(this.boxes) * Number(this.quantityPerBox) + Number(this.remaining) : Number(this.remaining);
      this.$emit('input', total);
    },
  },
}
</script>

<template>
  <div>
    <label>
      {{typeName}} {{unit | unitToDisplayText}}
      <span class="text-muted small"> (sum is {{value}}) </span>
    </label>

    <div class="row">
      <div v-if="showBoxes" class="col-6">
        <b-input-group>
          <b-input-group-text slot="prepend" style="width:2.5em;"> B </b-input-group-text>
          <b-form-input :id="`boxes-${_uid}`" v-model="boxes" type="number" min="0" @focus="$event.target.select()"></b-form-input>
        </b-input-group>
      </div>

      <div class="col-6">
        <b-input-group>
          <b-input-group-text slot="prepend" style="width:2.5em;"> {{unit | abbreviateStockTypeUnit}} </b-input-group-text>
          <b-form-input :id="`remaining-${_uid}`" v-model="remaining" type="number" min="0" @focus="$event.target.select()"></b-form-input>
        </b-input-group>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/layer/components/EggStockTypeQuantityInput.vue